import React, { useEffect, useState } from 'react';
import api from '../api';
import './BreakingNews.css';

function BreakingNews() {
  const [breakingNews, setBreakingNews] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchBreakingNews = async () => {
      try {
        const response = await api.get('/api/news/breaking');
        if (response.data.success) {
          setBreakingNews(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching breaking news:', error);
      }
    };

    fetchBreakingNews();
  }, []);

  useEffect(() => {
    if (breakingNews.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % breakingNews.length);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [breakingNews]);

  if (breakingNews.length === 0) return null;

  return (
    <div className="breaking-news">
      <div className="container breaking-container">
        <span className="breaking-label">⚡ ब्रेकिंग न्यूज़</span>
        <div className="breaking-content">
          <p>{breakingNews[currentIndex]?.title}</p>
        </div>
        <div className="breaking-dots">
          {breakingNews.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default BreakingNews;
